import React, { useEffect } from "react";
import xls from "xlsx";
import { useState, useRef } from "react";
import { Container, Row, Col } from "reactstrap";
import Dropdown from "react-bootstrap/Dropdown";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import { getFundByAmc } from "../../stores/services/funds.service";
import { env } from "../../env";
import { numberWithCommas } from "../../utils/customFunction";
import { legacyLedgersUploader } from "../../stores/services/legacyUploader";

const LegacyLedgerUploader = () => {

    const fileKeys = [
        "FundCode",
        "txnid",
        "OpeningBalance",
        "ClosingBalance",
        "MainFamilyCode",
        "MainFamilyName",
        "GlCode",
        "GlName",
        // "AmountType",
        // "Type",
        "Debit",
        "Credit",
        "Period",
        "Description",
        "SettlementDate",
        "FamilyCode",
        "FamilyName",
        "SubFamilyCode",
        "SubFamilyName",
        "ChildFamilyCode",
        "ChildFamilyName",
    ]

    const requiredFields = [
        "FundCode",
        // "txnid",
        "MainFamilyCode",
        "MainFamilyName",
        "GlCode",
        "GlName",
        // "Description",
        "Debit",
        "Credit",
        "FamilyCode",
        "FamilyName",
        "SubFamilyCode",
        "SubFamilyName",
        // "ChildFamilyCode",
        // "ChildFamilyName",
    ]

    const nonNumericFields = [
        "FundCode",
        "txnid",
        "MainFamilyCode",
        "MainFamilyName",
        "GlCode",
        "GlName",
        // "AmountType",
        // "Type",
        "Period",
        "Description",
        "SettlementDate",
        "FamilyCode",
        "FamilyName",
        "SubFamilyCode",
        "SubFamilyName",
        "ChildFamilyCode",
        "ChildFamilyName",
    ]

    const amcCode = sessionStorage.getItem("amc_code") || "";
    const [loading, setLoading] = useState(false);
    const [fileData, setfileData] = useState<any>([]);
    const [fileDataCount, setFileDataCount] = useState(0);
    const myRef1 = useRef<HTMLInputElement>(null);
    const [fileName, setFileName] = useState("");
    const [fileError, setFileError] = useState("");
    const [file, setFile] = useState("");
    const [fileUploadingFlag, setFileUploadingFlag] = useState<boolean>(false);
    const email = sessionStorage.getItem("email") || "";
    const [errorInFile, setErrorInFile] = useState(false)
    const [allAvailableFunds, setAllAvailableFunds] = useState<any>([])
    const [loadingFileUpload, setLoadingFileUpload] = useState(false)
    const [apiLoading, setApiLoading] = useState(false);
    const [megaBulkUpload, setMegaBulkUpload] = useState<any>([]);


    const allFunds = async () => {
        try {
            let res = await getFundByAmc(
                email,
                amcCode
            );
            if (res?.status === 200 && res?.data?.status === 200) {
                const temp = res?.data?.data?.map((item) => `${item?.symbol_code}`);
                setAllAvailableFunds(temp);
            }
        } catch (error) {
            console.log("error fetching funds", error);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            setApiLoading(true);
            try {
                await Promise.all([
                    allFunds(),
                ]);
            } catch (error) {
                console.log("Error during initial data fetch", error);
            } finally {
                setApiLoading(false);
            }
        };

        fetchData();
    }, [email, amcCode]);


    const upload = async (e: any) => {
        if (e?.target.files[0]) {
            setFileError("");
            setfileData(null);
            let file = e?.target.files[0];

            let type = file?.name?.substring(file?.name?.lastIndexOf(".") + 1);
            if (type === "xlsx" || type === "csv") {
                setFile(file);
                setFileName(file?.name);
                //start

                const reader = new FileReader();
                const rABS = !!reader.readAsBinaryString;
                reader.onload = (e) => {
                    /* Parse data */
                    const bstr = e.target?.result;
                    const wb = xls.read(bstr, { type: rABS ? "binary" : "array" });
                    /* Get first worksheet */
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];
                    /* Convert array of arrays */
                    const data: any = xls.utils.sheet_to_json(ws, {
                        header: 2,
                        raw: false,
                        defval: "",
                        dateNF: "YYYY-MM-DD",
                    });
                    // if file is empty 
                    if (data?.length === 0) {
                        toast.error("File Should not be empty")
                        setfileData([]);
                        setFileDataCount(0);
                        setFileName("")
                        return
                    }
                    // check if uploaded file doesn not contain any other key that is not present in sample file
                    const uploadedHeaders = Object.keys(data[0])?.filter((ele) => !ele?.includes("__EMPTY")).map(item => item.trim()?.toLowerCase());
                    // console.log("uploadedHeaders", uploadedHeaders)

                    const resetAndInvalidate = (message: string) => {
                        toast.error(message);
                        setfileData([]);
                        setFileDataCount(0);
                        setFileName("");
                    };


                    const headersMatch =
                        uploadedHeaders?.length > fileKeys?.length ?
                            uploadedHeaders?.every(header => {
                                return fileKeys?.includes(header?.trim()?.toLowerCase())
                            }) :
                            fileKeys?.every(header => {
                                return uploadedHeaders?.includes(header?.trim()?.toLowerCase())
                            });

                    if (data.some((ele) => !allAvailableFunds?.includes(ele?.FundCode?.toUpperCase()?.trim()))) {
                        const indexOfErr = data?.findIndex((item) => !allAvailableFunds?.includes(item?.FundCode?.toUpperCase()?.trim()))
                        resetAndInvalidate(`Invalid fund code. Please enter a valid fund for row ${indexOfErr + 2}`)
                        return
                    }


                    const checkRequiredFields = (data, requiredFields) => {
                        return data.some(row => {
                            return requiredFields.some(field => {
                                const value = row[field.trim()]?.toString().trim(); // get trim valu
                                return !value; // true if valu is emoty
                            });
                        });
                    };

                    const numericFields = [
                        "Credit",
                        "Debit",
                        "GlCode",
                        "OpeningBalance",
                        "ClosingBalance",
                        "MainFamilyCode",
                        "FamilyCode",
                        "SubFamilyCode",
                        "ChildFamilyCode",
                    ];

                    for (let i = 0; i < data.length; i++) {
                        const row = data[i];
                        for (const field of numericFields) {
                            const value = row[field];
                            if (value !== "" && isNaN(Number(value))) {
                                resetAndInvalidate(
                                    `Row ${i + 2}: '${field}' must be a number.`
                                );
                                return;
                            }
                        }
                    }

                    const hasEmptyRequiredFields = checkRequiredFields(data, requiredFields);
                    if (
                        hasEmptyRequiredFields
                    ) {
                        setErrorInFile(true);
                    } else {
                        setErrorInFile(false);
                    }



                    if (!headersMatch) {
                        toast.error("Uploaded file headers do not match the expected format.");
                        setfileData([]);
                        setFileDataCount(0);
                        setFileName("")
                        return;
                    }

                    /* Update state */

                    //  let jsonarray:any = [];
                    if (data.length > 0 && headersMatch) {
                        // filter those keys which has ___Empty 
                        const filteredData = data.map(obj => {
                            return Object.fromEntries(
                                Object.entries(obj).filter(([key]) => !key.startsWith('__EMPTY'))
                            );
                        });
                        const finalData = filteredData?.map((ele) => {
                            return {
                                fund_code: ele?.FundCode || "",
                                txn_id: ele?.txnid || "",
                                previous_balance: ele?.OpeningBalance || "",
                                balance: ele?.ClosingBalance || "",
                                main_family_code: ele?.MainFamilyCode || "",
                                main_family_name: ele?.MainFamilyName || "",
                                gl_code: ele?.GlCode || "",
                                gl_name: ele?.GlName || "",
                                // ledger_type: ele?.AmountType || "",
                                // doc_type: ele?.Type || "",
                                debit_amount: ele?.Debit || "",
                                credit_amount: ele?.Credit || "",
                                period: ele?.Period || "",
                                description: ele?.Description || "",
                                settlement_date: ele?.SettlementDate || "",
                                family_name: ele?.FamilyName || "",
                                family_code: ele?.FamilyCode || "",
                                sub_family_name: ele?.SubFamilyName || "",
                                sub_family_code: ele?.SubFamilyCode || "",
                                child_family_name: ele?.ChildFamilyName || "",
                                child_family_code: ele?.ChildFamilyCode || "",

                            }
                        })
                        setMegaBulkUpload(finalData)
                        setfileData(filteredData);
                        setFileDataCount(data.length);
                    }
                };
                if (rABS) reader.readAsBinaryString(file);
                else reader.readAsArrayBuffer(file);
                // end 2
            } else {
                toast.error("Please Upload Correct Format of File");
                setfileData([]);
                setFileDataCount(0);
                setFileName("")
            }
            // removing value so that user can upload same file again
            e.target.value = ""
        }

    };

    const renderTable = () => {
        return fileData?.map((item: any, index: number) => {
            return (
                <tr key={index}>
                    {Object.entries(item).map(([key, value]: [string, any]) => {
                        let isHighlighted = false;

                        if (requiredFields?.includes(key) && value?.trim() === "") {
                            isHighlighted = true;
                        }
                        return (
                            <td key={key}
                                style={{
                                    backgroundColor: isHighlighted ? "#8b0000" : "",
                                    border: "1px solid #525f7f"
                                }}
                            >
                                {Number(Number(value)) && !nonNumericFields?.includes(key)
                                    ? numberWithCommas(value?.split(".")?.length > 1 ? Number(value)?.toFixed(4) : Number(value))
                                    :
                                    key == "NAVDate" ?
                                        moment(value).format('M/D/YYYY') :
                                        value}
                            </td>
                        )
                    })}
                </tr>
            );
        });
    }

    const handleUploadFiles = async () => {
        setLoadingFileUpload(true)
        if (errorInFile === true) {
            toast.error("First fill the required fields")
            setLoadingFileUpload(false)
            return
        }
        try {
            let res = await legacyLedgersUploader(
                email,
                amcCode,
                megaBulkUpload
            )
            if (res?.data?.status === 200) {
                toast.success("Data Uploaded Successfully")
            }

        } catch (error: any) {
            if (error.response != undefined) {
                toast.error(error.response.data.message);
            } else {
                toast.error(error.message);
            }
        } finally {
            setLoadingFileUpload(false)
            setErrorInFile(false)
            setfileData([]);
            setFileDataCount(0);
            setFileName("")
            setMegaBulkUpload([])
        }
    }

    return (
        <>
            <div className="content">
                <Row>
                    <Col md="12">
                        <Container fluid>
                            <ToastContainer limit={1} />
                            <div className="card">
                                <div className="">
                                    <div className="card-header">
                                        <h4 className="card-title">
                                            Legacy Ledgers Bulk Upload
                                            <Dropdown className="float-right">
                                                <Dropdown.Toggle href={`${env.REACT_APP_SAMPLE_URL}Ledger.xlsx`} variant="dark" id="dropdown-basic">
                                                    Download Sample
                                                </Dropdown.Toggle>
                                            </Dropdown>
                                        </h4>
                                    </div>
                                    {apiLoading ?
                                        <Row className="d-flex justify-content-center my-3">
                                            <i
                                                className="fa fa-spinner fa-spin fa-3x"
                                                aria-hidden="true"
                                            ></i>
                                        </Row>
                                        :
                                        <div className="card-body">
                                            <Row className="mb-3">
                                                <Col md="6">
                                                    <label>Choose File </label>
                                                    <div
                                                        className="form-control multi-input ml-auto"
                                                        style={{
                                                            cursor: "pointer"
                                                        }}
                                                        onClick={() => myRef1?.current?.click()}
                                                    >
                                                        <div className="form-group mb-0">
                                                            <div className="fom-control ml-2">
                                                                {fileName === "" ? "Upload File" : fileName}
                                                            </div>
                                                            <input
                                                                className="form-control"
                                                                type="file"
                                                                ref={myRef1}
                                                                style={{ display: "none" }}
                                                                multiple={false}
                                                                onChange={(e) => {
                                                                    upload(e);
                                                                }}
                                                            />
                                                            {fileError ? (
                                                                <p className="error-labels error-message2">
                                                                    {fileError}
                                                                </p>
                                                            ) : (
                                                                ""
                                                            )}
                                                        </div>
                                                    </div>
                                                    {fileUploadingFlag && (
                                                        <img src="assets/loader.svg" width="50" />
                                                    )}
                                                </Col>
                                            </Row>
                                            {
                                                fileData?.length > 0 ? (
                                                    <div className="table-responsive">
                                                        <table
                                                            className="table mt-3 ">
                                                            <thead>
                                                                {
                                                                    Object.keys(fileData?.[0])?.map((heading) => {
                                                                        return (
                                                                            <th
                                                                                style={{
                                                                                    paddingLeft: "7px",
                                                                                    paddingRight: "7px",
                                                                                    border: "1px solid"
                                                                                }}
                                                                                className="text-nowrap"
                                                                            >
                                                                                {heading}
                                                                            </th>
                                                                        )
                                                                    })}

                                                            </thead>
                                                            <tbody>{renderTable()}</tbody>
                                                        </table>
                                                    </div>
                                                ) : (
                                                    fileName ?
                                                        <Row className="d-flex justify-content-center my-3">
                                                            <i
                                                                className="fa fa-spinner fa-spin fa-3x"
                                                                aria-hidden="true"
                                                            ></i>
                                                        </Row> : null
                                                )
                                            }
                                            Total Rows:{" "}
                                            <span className="text-primary mt-3">{fileDataCount} </span>
                                            <div className="mt-4">
                                                <button
                                                    className="btn btn-primary"
                                                    disabled={Boolean(loading) || fileData?.length < 1 || loadingFileUpload}
                                                    onClick={() => handleUploadFiles()}
                                                >
                                                    {loading || loadingFileUpload ? (
                                                        <>
                                                            <span
                                                                className="spinner-border login-txt spinner-border-sm"
                                                                role="status"
                                                                aria-hidden="true"
                                                            ></span>
                                                            <span className="login-txt"> Loading...</span>
                                                        </>
                                                    ) : (
                                                        <span>Upload</span>
                                                    )}
                                                </button>
                                            </div>
                                        </div>}
                                </div>
                            </div>
                        </Container>
                    </Col>
                </Row>
            </div>
        </>
    );
};

export default LegacyLedgerUploader;
